import React from 'react';

import { useSelector } from 'react-redux';

import { AccountStatusContext } from '@src/packages/utils/hooks/useAccountStatus';

import { useAccountStatusSubscription } from './hooks/useAccountStatusSubscription';

interface OrganizationState {
  organizations?: { organization?: { id?: string | null } };
}

interface AccountStatusProviderProps {
  children: React.ReactNode;
}

/** Live account status of the active organization, for the read-only gate, banner and block. */
export const AccountStatusProvider: React.FC<AccountStatusProviderProps> = ({ children }) => {
  const organizationId = useSelector(
    (state: OrganizationState) => state.organizations?.organization?.id,
  );
  const accountStatus = useAccountStatusSubscription(organizationId);

  return (
    <AccountStatusContext.Provider value={accountStatus}>{children}</AccountStatusContext.Provider>
  );
};
